import { Loader } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { Button } from '~/domains/design-system/Button';
import Dialog from '~/domains/design-system/components/Dialog/Dialog';
import DialogBody from '~/domains/design-system/components/Dialog/DialogBody/DialogBody';
import UnknownErrorScreen from '~/domains/common/components/UnknownErrorScreen/UnknownErrorScreen';

import { ContestManageModalTitle } from '../commonStyles';

import { useGameplayLearnHowModalStyles } from './style';
import { useGameplayLearnHowProxy } from './useGameplayLearnHowProxy';

export interface GameplayLearnHowModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
}

function GameplayLearnHowModal({ isOpen, onClose, url }: GameplayLearnHowModalProps) {
  const { t } = useTranslation('contest');
  const { classes, theme } = useGameplayLearnHowModalStyles();

  const {
    isLoading: isLoadingQuery,
    error: proxyError,
    isSuccess,
    data: validatedResponse,
    iframeLoaded,
    proxyUrl,
    setIframeLoaded,
  } = useGameplayLearnHowProxy({ url, isOpen });

  const isLoading = isLoadingQuery || (isSuccess && !proxyError && !iframeLoaded);

  return (
    <Dialog
      type={{
        desktop: 'modal',
        mobile: 'drawer',
      }}
      isOpen={isOpen}
      onClose={onClose}
    >
      <DialogBody className={classes.body}>
        <ContestManageModalTitle>
          {t('manage.common.modals.gameplayLearnHowModal.title')}
        </ContestManageModalTitle>
        <div className={classes.iframeContainer}>
          {proxyError && !isLoading && <UnknownErrorScreen statusCode={404} hideActions />}
          {!proxyError && !isLoadingQuery && validatedResponse && (
            <iframe
              src={proxyUrl}
              className={classes.iframe}
              title={t('manage.common.modals.gameplayLearnHowModal.title')}
              onLoad={() => setIframeLoaded(true)}
            />
          )}
          {isLoading && (
            <div className={classes.loadingOverlay}>
              <Loader color={theme.colors.blue[5]} size="lg" />
            </div>
          )}
        </div>
        <Button variant="primary-fill" fullWidth className={classes.button} onClick={onClose}>
          {t('manage.common.modals.gameplayLearnHowModal.cta')}
        </Button>
      </DialogBody>
    </Dialog>
  );
}

export default GameplayLearnHowModal;
